import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import AuthServices from '../app/auth-services';
import router from '../router/index';

Vue.use(Vuex)

//const API_URL = process.env.VUE_APP_API_URL;
//const EXIBITOR_API_URL = process.env.VUE_APP_EXIBITOR_API_URL;
//const USER_API_URL = process.env.VUE_APP_USER_API_URL;

//const POST_HEADERS = {
//    crossDomain: true,
//    headers:
//    {
//        "Access-Control-Allow-Origin": "*",
//        "Access-Control-Allow-Credentials": true
//    }
//}

//function getCurrentUser(context) {
//    let data = {
//        UserId: context.state.authUserInfo.Email,
//        UserDescription: context.state.cognitoInfo.given_name + ' ' + context.state.cognitoInfo.family_name,
//        ExhibitionId: process.env.VUE_APP_EXHIBITION_ID
//    }
//    return data;
//}

axios.interceptors.request.use(
    async function (config) {
        //This will get the cached session, or refresh the token first if it has expired
        let authHeader = await AuthServices.getCurrentAuthUserHeader();
        config.headers.Authorization = authHeader;
        return config;
    },
    async function (error) {
        if (error.response.status === 401) {
            router.push('/logout');
            return Promise.resolve(error.response);
        }
        return Promise.reject(error)
    })

export default new Vuex.Store({
    state: {
        // put variables and collections here
        authUserInfo: null,
        cognitoInfo: null,
        loggedIn: false,
        errorNotification: null,
        isLoading: false,
        nickname: null,
    },
    getters: {
        initialQuery(state) {
            let q = localStorage.getItem("vexpo_query");
            if (q) {
                return JSON.parse(q)
            }
            return;
        },
        initialToken(state) {
            return localStorage.getItem("vexpo_token")
        }
    },
    mutations: {
        // put sychronous functions for changing state e.g. add, edit, delete

        SET_AUTH_USER_INFO(state, value) {
            state.authUserInfo = value;
        },
        SET_LOGGED_IN(state, value) {
            state.loggedIn = value;
        },
        SET_LOGGED_OUT(state) {
            state.cognitoInfo = null;
            state.loggedIn = false;
            state.authUserInfo = null;
            state.initialQuery = null;
            state.initialToken = null;
            state.nickname = null;
            localStorage.removeItem("vexpo_query");
            localStorage.removeItem("vexpo_token")
        },
        SET_COGNITO_INFO(state, value) {
            state.cognitoInfo = value;
        },
        SET_ERRORNOTIFICATION(state, value) {
            state.errorNotification = value;
        },
        SET_LOADING(state, value) {
            state.isLoading = value;
        },

        SET_INITIAL_QUERY(state, value) {
            localStorage.setItem("vexpo_query",value);
        },
        SET_INITIAL_TOKEN(state, value) {
            localStorage.setItem("vexpo_token",value);
        },

        SET_NICKNAME(state, value) {
            state.nickname = value;
        },
    },
    actions: {
        // put asynchronous functions that can call one or more mutation functions

        //getAuthUserInfo(context) {
        //    let params = {
        //        params: {
        //            UserMail: context.state.cognitoInfo.email,
        //            ExhibitionId: process.env.VUE_APP_EXHIBITION_ID
        //        }
        //    };

        //    context.commit('SET_LOADING', true);
        //    return axios.get(USER_API_URL + '/userInfo', params)
        //        .then(res => {
        //            context.commit('SET_AUTH_USER_INFO', res.data);
        //        })
        //        .catch(() => {
        //            context.commit('SET_ERRORNOTIFICATION', "Si e' verificato un errore.");
        //        })
        //        .then(() => {
        //            context.commit('SET_LOADING', false);
        //        })
        //},
        setLoggedIn(context, data) {
            context.commit('SET_LOGGED_IN', data);
        },
        setLoggedOut(context) {
            context.commit('SET_LOGGED_OUT');
        },
        setCognitoInfo(context, data) {
            context.commit('SET_COGNITO_INFO', data);
        },
        setErrorNotification(context, data) {
            context.commit('SET_ERRORNOTIFICATION', data);
        },
        setLoading(context, data) {
            context.commit('SET_LOADING', data);
        },


        setInitialQuery(context, data) {
            context.commit('SET_INITIAL_QUERY', data);
        },
        setInitialToken(context, data) {
            context.commit('SET_INITIAL_TOKEN', data);
        },

        setNickname(context, data) {
            context.commit('SET_NICKNAME', data);
        },
        getNickname(context, data) {
            context.commit('SET_LOADING', true);
            return axios.get(process.env.VUE_APP_GET_NICKNAME)
                .then(response => {
                    context.commit('SET_NICKNAME', response.data.Nickname);

                    let param = this.getters.initialQuery;

                    if (!this.state.nickname) {
                        // user does not have a nickname - show 
                        router.push({ name: 'LoginNickname', params: param });
                    }
                    else {
                        // user has a nickname - redirect
                        router.push({ name: 'Home', params: param });
                    }
                })
                .catch(() => {
                    context.commit('SET_ERRORNOTIFICATION', "Si e' verificato un errore.");
                })
                .then(() => {
                    context.commit('SET_LOADING', false);
                })
        },
    }
});